export enum HTTP_METHOD {
  POST = "POST",
  PUT = "PUT",
  PATCH = "PATCH",
  DELETE = "DELETE",
  GET = "GET",
}

interface TypedResponse<T> extends Response {
  json(): Promise<
    T & {
      error?: string;
      errors?: string[];
    }
  >;
}

/**
 * Fetch from the API and define a return type to get
 * proper type hints back from the json response.
 *
 * example: fetchAPI<User> will be typed User in the res.json() response
 */
export const fetchAPI = async <T>(
  url: string,
  method: HTTP_METHOD = HTTP_METHOD.GET,
  body?: object | FormData
) => {
  let headers: HeadersInit = {};

  if (!(body instanceof FormData)) {
    headers = {
      "Content-Type": "application/json",
      Accept: "application/json",
    };
  }

  let init: RequestInit = {
    headers,
    method,
  };

  if (body) {
    init = {
      ...init,
      // Avoid JSON.stringify if the body is FormData
      body: body instanceof FormData ? body : JSON.stringify(body),
    };
  }

  const res = await fetch(url, init);

  // Handling for unauthorized requests and rate limiting
  if (
    res.status === 401 &&
    window.location.pathname.includes("/invite") === false
  ) {
    window.location.replace("/login");
  }

  if (res.status === 429) {
    window.alert("You are being throttled!! Slow down");
  }

  return res as TypedResponse<T>;
};
